import PageLocations from '@/pages/PageLocations'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageLocations
	}

	let page = vuewidget(dom, options)
	return page
}